import LayoutPedidoPage from './LayoutPedido'

export default function LayoutMapaPage() {
  return <LayoutPedidoPage tipoDoc="mapa" />
}
